import { Close } from '@mui/icons-material'
import { LocationOutlinedIcon } from '@/Components/UI/Icons'
import { type PreviousEventRequest } from '@/Components/RepeatEvent/PreviousEventCard'

interface RequestedVenuesSidebarProps {
  venues: PreviousEventRequest[]
  onRemove: (index: number) => void
}

const RequestedVenuesSidebar = ({ venues, onRemove }: RequestedVenuesSidebarProps) => (
  <div className='flex flex-col gap-4 justify-end'>
    <p className='font-semibold text-sm text-[#af231c] leading-[22px] tracking-[0.07px]'>
      Your requested venues ({venues.length}):
    </p>
    <div className='flex flex-col gap-2'>
      {venues.map((venue, i) => (
        <div
          key={i}
          className='bg-white border border-[#8c8c8c] rounded-[8px] flex items-stretch overflow-hidden'>
          <div
            className='w-[120px] min-h-[90px] shrink-0 bg-[#f0f0f0] bg-cover bg-center'
            style={venue.imageUrl ? { backgroundImage: `url("${venue.imageUrl}")` } : undefined}
          />
          <div className='flex-1 min-w-0 px-3 py-2 flex flex-col justify-center'>
            <p className='font-medium text-sm text-black leading-[22px] tracking-[0.07px] truncate'>
              {venue.spaceName}
              {venue.venueName && venue.venueName !== venue.spaceName
                ? ` at ${venue.venueName}`
                : ''}
            </p>
            {venue.location && (
              <div className='flex items-center gap-1'>
                <LocationOutlinedIcon width={12} height={14} />
                <span className='text-xs text-[#595959] truncate'>{venue.location}</span>
              </div>
            )}
          </div>
          <button
            type='button'
            onClick={() => onRemove(i)}
            aria-label={`Remove ${venue.spaceName}`}
            className='p-2 cursor-pointer shrink-0 text-[#8c8c8c] hover:text-black transition-colors flex items-center'>
            <Close className='size-4!' />
          </button>
        </div>
      ))}
    </div>
  </div>
)

export default RequestedVenuesSidebar
